import { dispatch } from 'store';
import { resetRootState } from './root.slice';

export const root_clearAllStates = () => {
  dispatch(resetRootState());

  sessionStorage.clear();
  localStorage.clear();
};
